import React, { useCallback } from 'react'
import { useParams, useLocation, useNavigate } from 'react-router-dom'

import _ from 'underscore'

import DeviceTabs from 'pages/shared/DeviceTabs'

import useDeviceSearch from 'hooks/useDeviceSearch'
import useSearchParams from 'hooks/useSearchParams'
import { useFeaturesContext } from 'hooks/FeaturesContext'

import { LoadingSinglePanePage, SinglePanePage } from 'styles/shared'

const MultipleDevices = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const { id: activeDeviceId } = useParams()
  const { enabledFeatures } = useFeaturesContext()

  const isSystemDashboardEnabled = enabledFeatures.includes('system_dashboard')
  const pathRoot = location.pathname.includes('/favorites') ? 'favorites' : 'devices'

  const deviceIdsSearchParam = useSearchParams('deviceIds')
  const deviceIds = _.uniq([...deviceIdsSearchParam?.split(',') || [], activeDeviceId]).sort()

  const { devices, areDevicesLoaded } = useDeviceSearch(deviceIds)

  const navigateToDevice = useCallback((deviceId: string) => {
    const toPath = `/${pathRoot}/multiple/${deviceId}${isSystemDashboardEnabled ? '/dashboard' : ''}`

    navigate(`${toPath}?deviceIds=${encodeURIComponent(deviceIdsSearchParam)}`, { state: location.state })
  }, [navigate, location.state, pathRoot, deviceIdsSearchParam, isSystemDashboardEnabled])

  if (!activeDeviceId) {
    return // invalid state, should never happen. <DeviceTabs> requires an activeDeviceId value
  }

  if (!areDevicesLoaded) {
    return <LoadingSinglePanePage />
  }

  return (
    <SinglePanePage>
      <DeviceTabs
        activeDeviceId={activeDeviceId}
        devices={devices || []}
        onActiveDeviceChangeCallback={navigateToDevice}
      />
    </SinglePanePage>
  )
}

export default MultipleDevices
